import { Injectable, signal } from '@angular/core';

import { firstValueFrom } from 'rxjs';

import { injectTellentIntelligenceHttp } from '@core/tellent-http-legacy';

import { AGENT_ID } from '../tellent-assistant-headers';

// Mirrors MCP_SERVER_NAME in tellent-ai — the prefix Mastra puts on MCP tool
// names when they ride the wire as agent tools.
const MCP_NAMESPACE_PREFIX = 'tellentSuite_';

@Injectable({ providedIn: 'root' })
export class ToolTitleRegistry {
  private readonly httpApi = injectTellentIntelligenceHttp();

  private readonly titles = signal<Record<string, string>>({});
  public readonly titlesSignal = this.titles.asReadonly();
  private fetchPromise: Promise<void> | null = null;

  public ensureLoaded(): Promise<void> {
    if (this.fetchPromise) return this.fetchPromise;
    this.fetchPromise = this.load().catch(err => {
      console.warn('Failed to load tool titles catalog:', err);
      this.fetchPromise = null;
    });
    return this.fetchPromise;
  }

  private async load(): Promise<void> {
    const body = await firstValueFrom(
      this.httpApi.get<{ titles?: ReadonlyArray<{ name: string; title: string }> }>(
        `/assistant/proxy/agents/${AGENT_ID}/tool-titles`,
      ),
    );
    // The endpoint serves MCP-namespaced names (`tellentSuite_list_jobs`) —
    // the shape legacy threads' direct tool-call parts carry — while
    // `data-tool-call` activity parts carry bare toolIds (`list_jobs`).
    // Register each title under both forms so both eras resolve.
    const titles: Record<string, string> = {};
    for (const { name, title } of body.titles ?? []) {
      titles[name] = title;
      if (name.startsWith(MCP_NAMESPACE_PREFIX)) {
        titles[name.slice(MCP_NAMESPACE_PREFIX.length)] = title;
      }
    }
    this.titles.set(titles);
  }
}
